import { Navigate } from 'react-router-dom';
import { PageSpinner } from '@/components/ui/page-spinner';
import { useCurrentUserOrgRole } from '@/hooks/useCurrentUserOrgRole';

/**
 * The org index route (`/org/:orgId`): the accounting overview for roles with
 * the `accounting` scope, the dashboard otherwise (a project manager —
 * docs/USER_ROLES_AND_PERMISSIONS.md). Relative targets resolve against the
 * org route, like the plain `<Navigate>` this replaces.
 */
export function OrgIndexRedirect() {
  const { can, isLoading } = useCurrentUserOrgRole();

  if (isLoading) {
    return <PageSpinner />;
  }

  return <Navigate to={can('accounting') ? 'accounting/overview' : 'dashboard'} replace />;
}
